import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { motion } from "framer-motion";
import AdminNavbar from "../Components/AdminNavbar";

export default function UploadImage() {
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [type, setType] = useState("Google");
  const [loading, setLoading] = useState(false);
  const [uploads, setUploads] = useState([]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    setPreview(URL.createObjectURL(file));
  };

  const fetchUploads = async () => {
    try {
      const res = await axios.get("https://dropshopi.com/api/all-uploads.php");
      if (res.data.status === "success") {
        setUploads(res.data.data || []);
      }
    } catch (err) {
      console.error("Failed to fetch uploads", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!image) {
      Swal.fire("Error", "Please select an image to upload.", "error");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("image", image);
    formData.append("type", type);

    try {
      const res = await axios.post("https://dropshopi.com/api/upload-image.php", formData);
      if (res.data.status === "success") {
        Swal.fire("Success", res.data.message, "success");
        setImage(null);
        setPreview(null);
        fetchUploads();
      } else {
        Swal.fire("Error", res.data.message, "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Something went wrong!", "error");
    }

    setLoading(false);
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Delete Image?",
      text: "This image will be deleted permanently.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!"
    });

    if (confirm.isConfirmed) {
      try {
        const res = await axios.post("https://dropshopi.com/api/delete-upload.php", { id });
        if (res.data.status === "success") {
          Swal.fire("Deleted!", res.data.message, "success");
          fetchUploads();
        } else {
          Swal.fire("Error", res.data.message || "Failed to delete image.", "error");
        }
      } catch (err) {
        console.error(err);
        Swal.fire("Error", "Something went wrong.", "error");
      }
    }
  };

  useEffect(() => {
    fetchUploads();
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="container py-5 text-white"
      style={{ background: "#121212", minHeight: "100vh" }}
    >
      <AdminNavbar />
      <h2 className="mb-4 text-warning">Upload Screenshots Image</h2>

      <div className="row">
        <div className="col-md-6">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Type</label>
              <select
                className="form-select bg-dark text-white border-secondary"
                value={type}
                onChange={(e) => setType(e.target.value)}
                required
              >
                <option value="Google">Google</option>
                <option value="Shopify">Shopify</option>
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">Image</label>
              <input
                type="file"
                accept="image/*"
                className="form-control bg-dark text-white border-secondary"
                onChange={handleImageChange}
                required
              />
              {preview && (
                <div className="mt-3">
                  <img src={preview} alt="Preview" style={{ width: "100%", maxHeight: 200, objectFit: "cover" }} />
                </div>
              )}
            </div>

            <button
              type="submit"
              className="btn btn-warning w-100"
              disabled={loading}
            >
              {loading ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              ) : (
                "Upload"
              )}
            </button>
          </form>
        </div>

        <div className="col-md-6">
          <h5 className="text-light mb-3">Uploaded Images</h5>
          <div className="table-responsive">
            <table className="table table-dark table-striped table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Image</th>
                  <th>Type</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {uploads.length === 0 ? (
                  <tr><td colSpan="5">No uploads found.</td></tr>
                ) : (
                  uploads.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>
  <a href={item.image_path} target="_blank" rel="noopener noreferrer">
    <img
      src={item.image_path}
      alt=""
      style={{ width: 60, height: 40, objectFit: "cover" }}
    />
  </a>
</td>

                      <td>{item.type}</td>
                      <td>{new Date(item.uploaded_at).toLocaleDateString()}</td>
                      <td>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(item.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
